import * as types from "./types";
import { get } from "@zendesk/knowledge-http-client";

const GROUPS_URL = "/api/v2/groups.json";
const AUTOCOMPLETE_URL = "/api/v2/groups/autocomplete.json";

function fetchInitialGroupsRequest() {
  return {
    type: types.FETCH_INITIAL_GROUPS_REQUEST,
  };
}

function fetchInitialGroupsSuccess(groups) {
  return {
    type: types.FETCH_INITIAL_GROUPS_SUCCESS,
    groups,
  };
}

function fetchInitialGroupsFailure(error) {
  return {
    type: types.FETCH_INITIAL_GROUPS_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchInitial() {
  return dispatch => {
    dispatch(fetchInitialGroupsRequest());

    return get(GROUPS_URL)
      .then(({ groups }) => dispatch(fetchInitialGroupsSuccess(groups)))
      .catch(err => {
        dispatch(fetchInitialGroupsFailure(err));
      });
  };
}

function fetchAutocompleteGroupsRequest(query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_GROUPS_REQUEST,
    query,
  };
}

function fetchAutocompleteGroupsSuccess(query, groups) {
  return {
    type: types.FETCH_AUTOCOMPLETE_GROUPS_SUCCESS,
    query,
    groups,
  };
}

function fetchAutocompleteGroupsFailure(error, query) {
  return {
    type: types.FETCH_AUTOCOMPLETE_GROUPS_FAILURE,
    error: true,
    payload: error,
    query,
  };
}

export function fetchAutocomplete(query) {
  return dispatch => {
    dispatch(fetchAutocompleteGroupsRequest(query));

    return get(`${AUTOCOMPLETE_URL}?name=${query}`)
      .then(({ groups }) =>
        dispatch(fetchAutocompleteGroupsSuccess(query, groups))
      )
      .catch(err => {
        dispatch(fetchAutocompleteGroupsFailure(err, query));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/groups/index.js